import Vue from 'vue'
import Vuex from 'vuex'
// import api from '@/api/commentApi'

// 下記参考
// https://aloerina01.github.io/javascript/vue/2017/08/29/1.html

// コンポーネント毎vuex分割
import commentsData from './components/commentsData'
import userData from './components/userData'
import modal from './components/modal'

Vue.use(Vuex)

const state = {}

const modules = {
  commentsData,
  userData,
  modal
}

const mutations = {}
const actions = {}
const getters = {}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js